export function applyImageFallback(
  img: HTMLImageElement,
  fallbackUrl?: string,
) {
  const nextUrl = fallbackUrl?.trim();

  if (!nextUrl) {
    img.onerror = null;
    return;
  }

  if (img.dataset.fallbackApplied === "true" || img.src === nextUrl) {
    img.onerror = null;
    return;
  }

  img.dataset.fallbackApplied = "true";
  img.src = nextUrl;
}
